import { helpers } from 'vuelidate/lib/validators';

export const ALLOWED_PASSWORD_SPECIAL_CHARS = '\\^$*.[\\]{}()?"!@#%&/\\\\,><\':;|_~`';
const pattern = `^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[${ALLOWED_PASSWORD_SPECIAL_CHARS}]).{8,}$`;

const forcePasswordPolicy = helpers.regex('forcePasswordPolicy', new RegExp(pattern));

const forceUsernamePolicy = helpers.regex('forceUsernamePolicy', /^[a-zA-Z0-9^$*.[\]{}()?"!@#%&/\\,><':;|_~`]+$/);
export {
  forcePasswordPolicy,
  forceUsernamePolicy,
};
